import { Component } from '@angular/core';
import {
  RdsFooterComponent,
  RdsFooterDisclaimerDirective,
  RdsFooterCaptionDirective
} from '@rds/angular-components';

@Component({
  selector: 'app-footer',
  imports: [
    RdsFooterComponent,
    RdsFooterDisclaimerDirective,
    RdsFooterCaptionDirective
  ],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {

}
